<script>
import n2c from "@/common/numberToChinese";
import BgSlider from "./BgSlider.vue";
import CountInput from "@/components/common/CountInput.vue";

import { fill, flattenDeep, cloneDeep } from "lodash";
import { endLoading } from "@/http/processing";
export default {
  components: {
    BgSlider,
    CountInput
  },
  props: {
    bgs: Array,
    staticBgs: Array,
    defaultBgs: Array,
    showAddModel: Boolean,
    shouldShow: Boolean,
    modelName: String,
    bgRatioData: Array
  },
  data() {
    const rolesControl =
      localStorage.getItem("roles").indexOf("ROLE_COMPLIANCE") > -1;
      console.log('aaaaa',this.bgs )
    return {
      precision: [],
      precisionConfig: {
        unit: "像素(px)",
        mix: 1,
        max: 100
      },
      colors: [
        "#86C4EB",
        "#C4BCF0",
        "#86D49F",
        "#F2D895",
        "#F59598",
        "#88EBE4",
        "#EE9BCD",
        "#FFC79F"
      ],
      popoverText: "",
      popVisible: false,
      dotBg: "",
      offsetTop: 0,
      rolesControl,
      hasdDiffArr: []
    };
  },
  computed: {
    totalDuration() {
      let duration = 0;
      if (this.bgs && this.bgs.length > 0) {
        this.bgs.forEach(bgInfo => {
          if (bgInfo.config && bgInfo.config.duration) {
            duration += parseInt(bgInfo.config.duration.value);
          }
        });
      }
      return duration;
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (document.getElementById("spectrum")) {
        this.offsetTop = document.getElementById("spectrum").offsetTop;
      }

      const hasdDiffArr = [];
      this.defaultBgs.forEach(obj => {
        this.staticBgs.forEach(objBgs => {
          if (obj.mode === objBgs.mode) {
            for (let propsNew in obj.config) {
              if (!objBgs.config[propsNew]) {
                hasdDiffArr.push(obj.mode);
              }
            }
          }
        });
      });
      this.hasdDiffArr = hasdDiffArr;
    });
  },
  methods: {
    n2c,
    addType(type) {
      this.bgs.push(JSON.parse(JSON.stringify(this.defaultBgs[0])));
    },
    deleteType(delIndex, type) {
      this.bgs.splice(delIndex, 1);
    },
    changeType(bgInfo, index, type) {
      this.bgs.splice(
        index,
        1,
        JSON.parse(
          JSON.stringify(
            this.defaultBgs.find(bg => {
              return bg.mode == bgInfo.mode;
            })
          )
        )
      );
    },
    handleMouseEnter(e, data) {
      const $pop = document.getElementById("popover");
      $pop.style.left = e.clientX - 180 + "px";
      this.popoverText = data.name + " " + data.value;
      this.dotBg = data.color;
      this.popVisible = true;
    },
    handleMouseLeave() {
      this.popVisible = false;
    },
    onClickAddBg(indexOfBgs, indexOfConfig, type) {
      if (indexOfConfig === "image") {
        this.bgs[indexOfBgs].config[indexOfConfig].imageList.push("");
      } else if (indexOfConfig === "color") {
        const arrLength = this.bgs[indexOfBgs].config[indexOfConfig]
          .colorList[0].length;
        const newRow = fill(Array(arrLength), "");
        this.bgs[indexOfBgs].config[indexOfConfig].colorList.push(newRow);
      }
    },
    onClickDelBg(indexOfBgs, indexOfConfig, index2) {
      if (indexOfConfig === "image") {
        let temp = this.bgs[indexOfBgs].config[
          indexOfConfig
        ].imageList.filter((o, index) => (index === index2 ? false : true));
        this.bgs[indexOfBgs].config[indexOfConfig].imageList = temp;
      } else if (indexOfConfig === "color") {
        let temp = this.bgs[indexOfBgs].config[
          indexOfConfig
        ].colorList.filter((o, index) => (index === index2 ? false : true));
        this.bgs[indexOfBgs].config[indexOfConfig].colorList = temp;
      }
    }
  }
};
</script>

<template>
  <div class="modelItem" v-if="shouldShow">
    <el-row>
      <el-col :span="3" class="tableLayOut">
        <p class="tableLabel">{{modelName}}</p>
      </el-col>
      <el-col :span="21" class="tableLayOut">
        <el-row>
          <el-col v-if="bgs && bgs.length > 0" :span="24" class="tableLayOut tableLabel">
            <div id="spectrum" class="spectrum">
              <div
                v-for="(item, index) in bgRatioData"
                :key="index"
                class="spectrum-item"
                :style="{width: item.ratio, backgroundColor: item.color}"
                @mouseenter="handleMouseEnter($event, item)"
                @mouseleave="handleMouseLeave"
                :title="item.name"
              >
                <span>{{item.name}}</span>
                <span style="margin-left: 6px;">{{item.size}}</span>
              </div>
            </div>
            <div class="alert">
              <i class="el-icon-info"></i>
              <p>
                背景由
                <span>{{bgs.length}}</span>种刺激模式组成，这几种刺激模式依次出现并构成一个循环，当前循环总时间为
                <span>{{totalDuration}}</span>毫秒
              </p>
            </div>
          </el-col>
          <el-row class="tableLayOut mode" v-for="(bgInfo, indexOfBgs) in bgs" :key="indexOfBgs">
            <el-col :span="3" class="tableLayOut">
              <div class="tableLabel">{{`刺激模式${n2c(indexOfBgs + 1)}`}}</div>
            </el-col>
            <el-col :span="21" class="tableLayOut tableLabel">
              <div class="bgOperation">
                <el-select
                  size="mini"
                  class="modeSelect"
                  v-model="bgInfo.mode"
                  @change="changeType(bgInfo, indexOfBgs)"
                >
                  <el-option
                    v-for="(typeInfo, index) in defaultBgs"
                    :key="index"
                    :label="typeInfo.name"
                    :value="typeInfo.mode"
                  />
                </el-select>
                <div class="operationBtn" @click="deleteType(indexOfBgs)">
                  <i class="el-icon-close"></i>
                  <p>删除刺激模式</p>
                </div>
                <el-tag
                  v-if="hasdDiffArr.length > 0 && hasdDiffArr.indexOf(bgInfo.mode) > -1"
                  style="margin-left: 10px"
                  size="mini"
                  type="warning"
                >该刺激背景有更新</el-tag>
              </div>

              <div v-for="(config, indexOfConfig) in bgInfo.config" :key="indexOfConfig">
                <div v-if="config.templateName && config.templateName === 'COLOR_GROUP_INPUT'">
                  <div
                    v-for="(item, index2) in config.colorList"
                    :key="index2"
                    class="bg-input-suffix"
                  >
                    背景颜色组{{n2c(index2 +1)}}
                    <el-input
                      v-for="(obj, index3) in item"
                      :key="index3"
                      class="bg-input"
                      size="small"
                      v-model="item[index3]"
                    >
                      <i
                        slot="suffix"
                        class="el-input__icon el-icon-picture"
                        :style="{'color': item[index3], 'background-color': item[index3],'border': '1px #666666 solid', 'line-height':'25px', 'height': '25px','margin':'2px 0'}"
                      ></i>
                    </el-input>
                    <div
                      v-if="index2 === 0"
                      class="bg-text-button"
                      @click="onClickAddBg(indexOfBgs,indexOfConfig )"
                    >
                      <div class="operationBtn">
                        <i class="el-icon-plus"></i>
                        <p>添加背景颜色组</p>
                      </div>
                    </div>
                    <div v-else-if="index2 >= config.colorLimitNumber" class="bg-text-button">
                      <div
                        class="operationBtn"
                        @click="onClickDelBg(indexOfBgs,indexOfConfig,index2)"
                      >
                        <i class="el-icon-close"></i>
                        <p>删除背景颜色组</p>
                      </div>
                    </div>
                  </div>
                </div>
                <BgSlider
                  v-if="config.templateName === 'SLIDER_INPUT'"
                  :name="config.name"
                  v-model="config.value"
                  :unit="config.unit"
                  :min="config.min"
                  :max="config.max"
                />

                <div v-if="config.templateName && config.templateName === 'IMAGE_GROUP_INPUT'">
                  <div
                    v-for="(obj, index2) in config.imageList"
                    :key="index2"
                    class="bg-input-suffix"
                  >
                    背景图片{{n2c(index2+1)}}
                    <el-input
                      class="bg-photo-input"
                      size="small"
                      v-model="config.imageList[index2]"
                    ></el-input>
                    <div
                      v-if="index2 === 0"
                      class="bg-text-button"
                      @click="onClickAddBg(indexOfBgs,indexOfConfig )"
                    >
                      <div class="operationBtn">
                        <i class="el-icon-plus"></i>
                        <p>添加背景图片</p>
                      </div>
                    </div>
                    <div v-else-if="index2 >= config.imageLimitNumber" class="bg-text-button">
                      <div
                        class="operationBtn"
                        @click="onClickDelBg(indexOfBgs,indexOfConfig,index2)"
                      >
                        <i class="el-icon-close"></i>
                        <p>删除背景图片</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="config.templateName && config.templateName === 'SWITCH_INPUT'"
                  class="bg-input-suffix"
                >
                  {{config.name}}
                  <el-switch
                    v-model="config.isClockWise"
                    class="switch-bg"
                    active-text="顺时针"
                    inactive-text="逆时针"
                  >></el-switch>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-col :span="24" class="tableLayOut tableLabel addClass">
            <div v-if="showAddModel" class="add-mode" @click="addType">
              <i class="el-icon-circle-plus-outline"></i>
              <p>增加刺激模式</p>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss">
.modelItem {
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #00c1de;
    background-color: #fff;
  }

  .el-radio__inner::after {
    background-color: #00c1de;
  }

  .el-radio__input.is-checked + .el-radio__label {
    color: #00c1de;
  }

  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #00c1de;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #00c1de;
    background-color: #00c1de;
  }

  .el-slider__bar {
    background-color: #00c1de;
  }

  .el-slider__button {
    border-color: #00c1de;
  }

  .el-switch.is-checked .el-switch__core {
    border-color: #00c1de;
    background-color: #00c1de;
  }

  .el-switch__label.is-active {
    color: #00c1de;
  }

  .mode {
    position: relative;

    > p {
      line-height: 26px;
    }

    &:last-child .line {
      display: none;
    }

    .bgOperation {
      height: 32px;
      display: flex;
      align-items: center;
      margin-bottom: 23px;

      .bgButton {
        margin: 0 10px;
      }
    }

    .bgInput {
      width: 120px;
    }
  }

  .alert {
    height: 42px;
    background: rgba(249, 251, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(237, 240, 245, 1);
    display: flex;
    align-items: center;
    margin-top: 10px;

    > i {
      color: #00adc7;
      margin-right: 8px;
      margin-left: 29px;
    }

    > p > span {
      color: #00adc7;
    }
  }

  .spectrum {
    display: flex;
    width: 100%;
    height: 20px;
    line-height: 20px;
    margin-top: 6px;
    color: #fff;
    font-size: 12px;

    .spectrum-item {
      box-sizing: border-box;
      padding: 0 6px;
      // margin-right: 1px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;

      &:last-child {
        margin-right: 0;
      }
    }
  }
  .el-row {
    border-top: 1px solid #f2f4f6;
    border-left: 1px solid #f2f4f6;
    border-right: 1px solid #f2f4f6;

    .tableLabel {
      padding: 20px 10px;
    }

    .numberGroup {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      > p {
        padding: 0 20px;
        margin: 10px;
        display: flex;
        align-items: center;

        > div {
          width: 100px;
          // height: ;
          margin: 0 10px;
        }
      }

      .config-slider {
        > div {
          display: inline-block;
          width: 300px;
        }
      }

      .config-textarea {
        width: 250px;
      }

      .config-imageGroup {
        width: 515px;
      }

      .bg-input {
        display: inline-block;
        height: 32px;
        width: 100px;
        padding: 0 5px;
      }
    }

    .radio-select {
      display: flex;

      .el-radio-group {
        display: flex;
      }
    }

    .bg-input-suffix {
      margin: 12px 0px;

      .bg-input {
        display: inline-block;
        height: 32px;
        width: 100px;
        padding: 0 5px;
      }

      .bg-select {
        width: 200px;
      }

      .bg-photo-input {
        width: 515px;
        display: inline-block;
        height: 32px;

        padding: 0 5px;
      }

      .bg-text-button {
        display: inline-block;
      }

      .switch-bg {
        padding: 0 15px;
      }
    }

    .tableLayOut {
      border-top: 1px solid #f2f4f6;
      border-left: 1px solid #f2f4f6;
      border-right: 1px solid #f2f4f6;
    }

    .modeSelect {
      width: 300px;
    }

    .addClass {
      .add-mode:hover {
        color: #00dafa;
      }
    }

    .add-mode {
      text-align: center;
      margin-left: 20px;
      color: #00adc7;
      cursor: pointer;

      > i {
        margin-right: 10px;
        font-size: 16px;
        font-weight: 500;
      }

      > p {
        display: inline-block;
      }
    }

    .operationBtn {
      align-items: center;
      display: flex;
      margin-left: 20px;
      color: #00adc7;
      cursor: pointer;

      > i {
        margin-right: 10px;
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bgConfig/modelItem.vue